import { combineReducers } from "redux";
import events from "./events";
import eventsNewsList from "./eventNewsListReducer";
import eventsNewsDetail from "./eventNewsDetailReducer";
import relatedNewsListReducer from "./relatedNewsListReducer";
import changeLanguage from "./changeLanguage";
import districtList from "./districtList";
import dashboards from "./dashboards";
import teamList from "./teamList";
import faq from "./faq";
import faqCategory from "./faqCategory";
import homePageLatestNews from './homePage'
import homePageMapsInfography from './homepageMapsInfography';
import sliderList from './slider';
import gallery from './gallery';
import galleryDetail from "./galleryDetail";
import marqueeList from "./marquee";
import partnerStoriesList from './homePagePartnerStories';
import mapDataList from "./mapList";
import mapCategory from "./mapCategoryList";
import infographiCategory from './infographicCategory';
import infographicList from './infographicList';
import homePageHrrpReference from "./homePageHrrpReference";
import resourceMaterialCategoryList from './recourceMaterialCategory'
import meeting from "./meeting";
import meetingCategory from "./meetingCategory";
import meetingDetail from "./meetingDetail";
import homePageRecentMinutes from './homePageRecentMinutes';
import teamCategory from "./teamCategory";
import partnersList from './partnersList';
import districtInfography from "./districtInfography";
import districtMapList from './districtMapList';
import settings from './settings';
import csvData from './storeCSVfile'
import mapData from './storeMapData'
import showPreloader from './showPreloader'
import partnerStories from './partnerStories'

const mainReducer = combineReducers({
    events,
    eventsNewsDetail,
    eventsNewsList,
    relatedNewsListReducer,
    changeLanguage,
    districtList,
    dashboards,
    teamList,
    faq,
    faqCategory,
    homePageLatestNews,
    sliderList,
    homePageMapsInfography,
    gallery,
    galleryDetail,
    marqueeList,
    partnerStoriesList,
    mapDataList,
    mapCategory,
    infographiCategory,
    infographicList,
    homePageHrrpReference,
    resourceMaterialCategoryList,
    meeting,
    meetingCategory,
    meetingDetail,
    homePageRecentMinutes,
    teamCategory,
    partnersList,
    districtMapList,
    districtInfography,
    settings,
    csvData,
    mapData,
    showPreloader,
    partnerStories
});

export default mainReducer;